import { useField } from "formik";
import SignaturePad from "./SignaturePad";
import styles from "./DrawnSignatures.module.css";

export type Signatory = { nom: string; role: string };
type SignatureEntry = { nom: string; role: string; img: string };

export default function DrawnSignatures({
  signatories,
  name = "signatures",
  compact = false,
}: {
  signatories: Signatory[];
  name?: string;
  compact?: boolean;
}) {
  const [{ value }, , { setValue }] = useField<SignatureEntry[]>(name);

  function update(index: number, img: string | null) {
    const next = signatories.map((signatory, i) => ({
      nom: signatory.nom,
      role: signatory.role,
      img: i === index ? img ?? "" : value?.[i]?.img ?? "",
    }));
    setValue(next);
  }

  if (signatories.length === 0) return null;

  return (
    <div className={styles.grid}>
      {signatories.map((signatory, i) => (
        <SignaturePad
          key={`${signatory.role}-${i}`}
          label={`${
            signatory.role === "bailleur" ? "Bailleur" : "Locataire"
          } · ${signatory.nom}`}
          onChange={(img) => update(i, img)}
          compact={compact}
        />
      ))}
    </div>
  );
}
